import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { NotificationDTO, Policy } from "../../types/workgroup";
import policyApi, { SetGetPolicyReqDTO } from "../api/PolicyApi";

interface PolicyState {
  policyList: Policy[] | undefined;
  fileLinkPolicy?: SetGetPolicyReqDTO;
  fileUrlToken?: string;
  policyNoti?: NotificationDTO;
}

// # initial state
const initialState: PolicyState = {
  policyList: undefined,
  fileLinkPolicy: undefined,
  fileUrlToken: undefined,
};

export const trunkSetpolicyList = createAsyncThunk(
  "policy/set",
  async (reqDTO: SetGetPolicyReqDTO) => {
    return await policyApi.setPolicy(reqDTO);
  }
);
export const trunkGetpolicyList = createAsyncThunk(
  "policy/get",
  async (reqDTO: SetGetPolicyReqDTO) => {
    return await policyApi.getPolicy(reqDTO);
  }
);
export const trunkSetPoliciesList = createAsyncThunk(
  "policies/set",
  async (reqDTO: SetGetPolicyReqDTO) => {
    const result = await policyApi.setPolicies(reqDTO);
    return result;
  }
);
export const trunkSetLinkFilePolicy = createAsyncThunk(
  "policy/set/fileLink",
  async (reqDTO: SetGetPolicyReqDTO) => {
    return await policyApi.setFileLinkPolicy(reqDTO);
  }
);
export const trunkGetLinkFilePolicy = createAsyncThunk(
  "policy/get/fileLink",
  async (reqDTO: SetGetPolicyReqDTO) => {
    return await policyApi.getFileLinkPolicy(reqDTO);
  }
);
export const trunkCheckFilePWValid = createAsyncThunk(
  "policy/valid",
  async (reqDTO: { uuid: string; password: string }) => {
    return await policyApi.checkFilePWValid(reqDTO);
  }
);
export const trunkGetPolicyNoti = createAsyncThunk(
  "policy/noti/get",
  async () => {
    return await policyApi.getPolicyNoti();
  }
);
export const trunkUpdatePolicyNoti = createAsyncThunk(
  "policy/noti/update",
  async (req: NotificationDTO) => {
    return await policyApi.updatePolicyNoti(req);
  }
);

const contentSlice = createSlice({
  name: "policy",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkSetpolicyList.fulfilled,
      (state, { payload: policy }) => {
        state.policyList = policy;
      }
    );
    builder.addCase(
      trunkGetpolicyList.fulfilled,
      (state, { payload: policy }) => {
        state.policyList = policy;
      }
    );
    builder.addCase(
      trunkGetLinkFilePolicy.fulfilled,
      (state, { payload: policy }) => {
        state.fileLinkPolicy = policy;
      }
    );
    builder.addCase(
      trunkSetLinkFilePolicy.fulfilled,
      (state, { payload: policy }) => {
        state.fileLinkPolicy = policy;
      }
    );
    builder.addCase(
      trunkCheckFilePWValid.fulfilled,
      (state, { payload: resp }) => {
        state.fileUrlToken = resp.apiToken;
      }
    );
    builder.addCase(
      trunkGetPolicyNoti.fulfilled,
      (state, { payload: resp }) => {
        state.policyNoti = resp;
      }
    );
    builder.addCase(trunkUpdatePolicyNoti.fulfilled, (state, req) => {
      state.policyNoti = req.payload;
    });
  },
});

export const contentAction = contentSlice.actions;
export default contentSlice.reducer;
